import './FormStyles.css';
import useInputString from '../../hooks/useInputString';
import { useState } from 'react';
import ClassicButton from '../UI/ClassicButton/ClassicButton';
import { resetPassword } from '../../http/userAPI';
import FromAlert from './FromAlert';
import { XLg } from 'react-bootstrap-icons';

interface ResetPasswordFormProps {
    closeModal: () => void;
}

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({ closeModal }) => {
    const [isLoading, setLoading] = useState<boolean>(false)
    const email = useInputString('');
    const [errorFields, setErrorFields] = useState<string[]>([]);
    const [isAlertVisible, setAlertVisible] = useState<boolean>();
    const [alertMessage, setAlertMessage] = useState<string>();
    
    const closeAlert = () => {
        setAlertVisible(false);
    };
    
    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        
        const missingFields = [];
        if (!email.value) missingFields.push('email');
        
        if (missingFields.length > 0) {
            setAlertMessage('Напишите Email.');
            setAlertVisible(true);
            setErrorFields(missingFields);
            setLoading(false);
            return;
        }
        
        resetPassword(email.value)
            .then((response) => {
                if (response.error) {
                    setAlertMessage(response.error); 
                    setAlertVisible(true);
                } else {
                    setAlertMessage(response.message); 
                    setAlertVisible(true);
                }
            })
            .catch((error) => {
                setAlertMessage('Произошла ошибка при сбросе пароля. Попробуйте позже.'); 
                setAlertVisible(true);
            })
            .finally(() => {
                setLoading(false); 
                setErrorFields([]); 
            });
    };
    
    return (
        <div className='form_container'>
            <h2>Сброс пароля</h2>
            <form className="form">
                {isAlertVisible && (
                    <FromAlert onClose={closeAlert}>
                        {alertMessage}
                    </FromAlert>
                )}
                
                <div className={`form_inputContainer`}>
                    <p>Почта</p>
                    <input
                        className={`email ${errorFields.includes('email') ? 'error' : ''}`}
                        type="email"
                        value={email.value}
                        onChange={email.onChange}
                        autoComplete="email"
                    />
                </div>
                
                <ClassicButton isLoading={isLoading} onClick={handleLogin} width='60%' height='40px' innerLoaderSize='20px'>
                    Сбросить пароль
                </ClassicButton>
            </form>
            
            <XLg className='form_closeButton' onClick={closeModal} />
        </div>
    );
}

export default ResetPasswordForm;